import React from 'react';
import { Badge, BadgeText } from '@gluestack-ui/themed';

type BadgeSize = 'sm' | 'md' | 'lg';
type TextSize = '2xs' | 'xs' | 'sm';

interface LabelValueBadgeProps {
  label: string;
  value: string | number;
  size?: BadgeSize;
  variant?: 'solid' | 'outline';
  formatValue?: (value: string | number) => string;
}

const LabelValueBadge: React.FC<LabelValueBadgeProps> = ({
  label,
  value,
  size = 'sm',
  variant = 'solid',
  formatValue,
}) => {
  // Calculate badge height based on size
  const height = {
    sm: 30,
    md: 36,
    lg: 42,
  }[size];

  const innerHeight = {
    sm: 24,
    md: 30,
    lg: 36,
  }[size];

  // Scale text size with badge size
  const textSize = ({
    sm: '2xs',
    md: 'xs',
    lg: 'sm',
  }[size] || 'xs') as TextSize;

  const displayValue = formatValue ? formatValue(value)
    : typeof value === 'number' ? value.toFixed(1) : value;

  return (
    <Badge
      action="muted"
      pr="$2"
      size={size}
      height={height}
      variant={variant}
      borderRadius="$full"
    >
      <Badge
        action="muted"
        bg="$white"
        px="$2"
        size={size}
        borderWidth={1}
        borderColor="$borderLight100"
        height={innerHeight}
        variant={variant}
        borderRadius="$full"
        ml={-3}
        mr="$2"
      >
        <BadgeText size={textSize}>{label}</BadgeText>
      </Badge>
      <BadgeText size={textSize} pr="$1">
        {displayValue}
      </BadgeText>
    </Badge>
  );
};

export default LabelValueBadge;
